const paymentOtherActiveReducer = (state = false, action) => {
	switch(action.type){
	case 'PAYMENTOTHERFALSE':	
		return false;
	case 'PAYMENTOTHERTRUE':
		return true;
	default:
		return state;
	}
}

export default paymentOtherActiveReducer;